<template>
  <div class="container">
    <Loading v-show="showLoading" />
    <div v-if="$store.state.subProject" class="card">
      <div>
        <h1>Sensores</h1>
        <v-layout row>
          <v-flex xs7 sm7 md7 lg7>
            <h4>
              Reporte de: <strong>{{ this.dateA }}</strong>
            </h4>
          </v-flex>

          <v-flex>
            <v-menu
              ref="calendar"
              v-model="calendar"
              :close-on-content-click="false"
              :nudge-right="40"
              :return-value.sync="dateA"
              lazy
              dark
              transition="scale-transition"
              offset-y
              full-width
              min-width="290px"
            >
              <template v-slot:activator="{ on }">
                <v-text-field
                  v-model="dateA"
                  label="Calendario"
                  prepend-icon="mdi-calendar"
                  readonly
                  v-on="on"
                />
              </template>
              <v-date-picker v-model="dateA" locale="es">
                <v-spacer />
                <v-btn flat color="primary" @click="calendar = false"
                  >Cancel</v-btn
                >
                <v-btn flat color="primary" @click="calendarClick()">OK</v-btn>
              </v-date-picker>
            </v-menu>
          </v-flex>
        </v-layout>

        <!-- <material-notification class="mb-3" color="warning" dismissible>
          <p>
          <strong>ATENCIÓN!!!</strong>
          YA PUEDES ELEGIR LA FECHA DEL REPORTE, ESTAS VIENDO EL DIA DE HOY!!! PARA VER EL REPORTE DEL DIA ANTERIOR FAVOR DE CAMBIAR LA FECHA
          </p> 
        </material-notification> -->

        <template v-if="readySoil">
          <v-card v-if="$store.state.agroBotSoil.length > 0">
            <v-toolbar color="light-green lighten-2" dark class="title">
              <v-toolbar-title
                center
                style="color: white !important; text-align: center !important;"
                class="justify-center"
              >
                SOIL
              </v-toolbar-title>
            </v-toolbar>
            <v-data-table
              :headers="headersAgroBotSoil"
              :items="agroBotSoil"
              must-sort
              :pagination.sync="pagination"
              class="elevation-1"
            >
              <template v-slot:items="props">
                <td>{{ props.item.name.split("_")[0] }}</td>
                <!-- <td class="text-xs-center">
                  {{
                    props.item.specificTypeParameters.avrgEC !== 0
                      ? props.item.specificTypeParameters.avrgEC
                      : "-"
                  }}
                  dS/m
                </td>
                <td class="text-xs-center">
                  {{
                    props.item.specificTypeParameters
                      .electricConductivityParsed !== 0
                      ? props.item.specificTypeParameters
                          .electricConductivityParsed
                      : "-"
                  }}
                  dS/m
                </td> -->
                <td class="text-xs-center">
                  {{
                    `${props.item.specificTypeParameters.avrgEC}dS/m ${
                      props.item.name.split("_")[1]
                    }cm`
                  }}
                </td>
                <td class="text-xs-center">
                  {{
                    `${
                      props.item.specificTypeParameters
                        .electricConductivityParsed
                    }dS/m ${props.item.name.split("_")[1]}cm`
                  }}
                </td>
                <td class="text-xs-center">
                  {{
                    props.item.specificTypeParameters.avrHumA !== 0
                      ? `${props.item.specificTypeParameters.avrHumA}% ${
                          props.item.name.split("_")[1]
                        }cm`
                      : "-"
                  }}
                </td>
                <td class="text-xs-center">
                  {{
                    props.item.specificTypeParameters.avrHumB !== 0
                      ? `${props.item.specificTypeParameters.avrHumB}% ${
                          props.item.name.split("_")[2]
                        }cm`
                      : "-"
                  }}
                </td>
              </template>
            </v-data-table>
          </v-card>
          <br />
        </template>

        <template v-if="ready">
          <v-toolbar color="light-green lighten-2" dark class="title">
            <v-toolbar-title
              center
              style="color: white !important; text-align: center !important;"
              class="justify-center"
            >
              PRO
            </v-toolbar-title>
          </v-toolbar>
          <v-data-table
            :headers="headersAgroBot"
            :items="agroBotBasic"
            must-sort
            :pagination.sync="pagination"
            class="elevation-1"
          >
            <template v-slot:items="props">
              <td>{{ props.item.name }}</td>
              <td class="text-xs-center">
                {{
                  props.item.specificTypeParameters.avrgDrainEC !== 0
                    ? props.item.specificTypeParameters.avrgDrainEC
                    : "-"
                }}
                dS/m
              </td>
              <td class="text-xs-center">
                {{
                  props.item.specificTypeParameters.lastEC !== 0
                    ? props.item.specificTypeParameters.lastEC
                    : "-"
                }}
                dS/m
              </td>
              <td class="text-xs-center">
                {{
                  props.item.specificTypeParameters.avrgDrainES !== 0
                    ? props.item.specificTypeParameters.avrgDrainES
                    : "-"
                }}
                dS/m
              </td>
              <td class="text-xs-center">
                {{
                  props.item.specificTypeParameters.lastES !== 0
                    ? props.item.specificTypeParameters.lastES
                    : "-"
                }}
                dS/m
              </td>
              <td class="text-xs-center">
                {{
                  props.item.specificTypeParameters.avrgPH !== 0
                    ? props.item.specificTypeParameters.avrgPH
                    : "-"
                }}
              </td>
              <td class="text-xs-center">
                {{
                  props.item.specificTypeParameters.yesterdayTotalPulsesComp
                    ? props.item.specificTypeParameters.yesterdayTotalPulsesComp
                    : "-"
                }}
                ml
              </td>
              <td class="text-xs-center">
                {{
                  props.item.specificTypeParameters.yesterdayTotalPulsesComp
                    ? Math.round(
                        props.item.specificTypeParameters
                          .yesterdayTotalPulsesComp * 0.023
                      )
                    : "-"
                }}
                mg
              </td>
              <td class="text-xs-center">
                {{
                  props.item.specificTypeParameters.yesterdayTotalPulses
                    ? Math.round(
                        props.item.specificTypeParameters.yesterdayTotalPulses
                      )
                    : "-"
                }}
                ml
              </td>
              <td
                :class="
                  props.item.specificTypeParameters.yesterdayTotalPulses /
                    props.item.specificTypeParameters.yesterdayTotalPulsesComp <
                  0.2
                    ? 'war text-xs-center'
                    : 'text-xs-center'
                "
              >
                {{
                  Math.round(
                    (props.item.specificTypeParameters.yesterdayTotalPulses /
                      props.item.specificTypeParameters
                        .yesterdayTotalPulsesComp) *
                      100
                  )
                }}%
              </td>
            </template>
          </v-data-table>
        </template>
        <br />

        <template v-if="ready2">
          <v-toolbar color="light-green lighten-2" dark class="title">
            <v-toolbar-title
              center
              style="color: white !important; text-align: center !important;"
              class="justify-center"
            >
              LIGHT
            </v-toolbar-title>
          </v-toolbar>
          <v-data-table
            :headers="headersAgroBotLight"
            :items="agroBotLight"
            must-sort
            :pagination.sync="pagination"
            class="elevation-1"
          >
            <template v-slot:items="props">
              <td>{{ props.item.name }}</td>
              <td class="text-xs-center">
                {{
                  props.item.specificTypeParameters.avrgDrainEC !== 0
                    ? props.item.specificTypeParameters.avrgDrainEC
                    : "-"
                }}
                dS/m
              </td>
              <td class="text-xs-center">
                {{
                  props.item.specificTypeParameters.lastEC !== 0
                    ? props.item.specificTypeParameters.lastEC
                    : "-"
                }}
                dS/m
              </td>
              <td class="text-xs-center">
                {{
                  props.item.specificTypeParameters.yesterdayTotalPulsesA
                    ? props.item.specificTypeParameters.yesterdayTotalPulsesA *
                      props.item.description
                    : "-"
                }}
                ml
              </td>
              <td class="text-xs-center">
                {{
                  props.item.specificTypeParameters.yesterdayTotalPulsesA
                    ? Math.round(
                        props.item.specificTypeParameters
                          .yesterdayTotalPulsesA * 0.023
                      )
                    : "-"
                }}
                mg
              </td>
              <td class="text-xs-center">
                {{
                  props.item.specificTypeParameters.yesterdayTotalPulsesB
                    ? Math.round(
                        props.item.specificTypeParameters.yesterdayTotalPulsesB
                      )
                    : "-"
                }}
                ml
              </td>
              <td
                :class="
                  props.item.specificTypeParameters.yesterdayTotalPulsesB /
                    props.item.specificTypeParameters.yesterdayTotalPulsesA <
                  0.2
                    ? 'war text-xs-center'
                    : 'text-xs-center'
                "
              >
                {{
                  Math.round(
                    (props.item.specificTypeParameters.yesterdayTotalPulsesB /
                      (props.item.specificTypeParameters.yesterdayTotalPulsesA *
                        props.item.description)) *
                      100
                  )
                }}%
              </td>
            </template>
          </v-data-table>
        </template>
        <br />
        <p>Promedio de las últimas 24 horas cuando hay drenaje *</p>
        <p>Lectura del último drenaje **</p>
        <p>Valor calculado indirectamente ***</p>
        <br />
        <hr />
      </div>

      <div v-if="$store.state.companyId === 1 && $store.state.userId !== 22">
        <div>
          <br />
          <br />
          <h1>{{ rancho }}</h1>
          <v-layout row wrap>
            <v-flex xs12 sm12 md7 lg7>
              <h2>Reporte Diario</h2>
            </v-flex>
            <v-flex xs12 sm12 md5 lg5>
              <v-menu
                ref="menu"
                v-model="menu"
                :close-on-content-click="false"
                :nudge-right="40"
                :return-value.sync="date"
                lazy
                dark
                transition="scale-transition"
                offset-y
                full-width
                min-width="290px"
              >
                <template v-slot:activator="{ on }">
                  <v-text-field
                    v-model="date"
                    label="Calendario"
                    prepend-icon="mdi-calendar"
                    readonly
                    v-on="on"
                  />
                </template>
                <v-date-picker v-model="date" locale="es">
                  <v-spacer />
                  <v-btn flat color="primary" @click="menu = false"
                    >Cancel</v-btn
                  >
                  <v-btn flat color="primary" @click="onClick()">OK</v-btn>
                </v-date-picker>
              </v-menu>
            </v-flex>
          </v-layout>

          <!-- <template v-if="!isWeekend"> -->
          <template>
            <v-layout row justify-center>
              <v-flex xs9 sm9 md9 lg9>
                <v-data-table
                  :headers="headers"
                  :items="items"
                  :pagination.sync="pagination"
                  must-sort
                  rows-per-page-text
                  hide-actions
                  class="elevation-1"
                  expand
                  header-length="20px"
                >
                  <template v-slot:items="props">
                    <td>{{ props.item.nave }}</td>
                    <td>{{ props.item.sector }}</td>
                    <td>{{ props.item["CE Gotero"] }}</td>
                    <td>{{ props.item["CE Drenaje"] }}</td>
                    <td>{{ props.item["pH Gotero"] }}</td>
                    <td>{{ props.item["pH Drenaje"] }}</td>
                  </template>
                </v-data-table>
              </v-flex>
              <v-flex xs7 sm7 md7 lg7>
                <v-data-table
                  :headers="headers2"
                  :items="data2"
                  :pagination.sync="pagination"
                  must-sort
                  rows-per-page-text
                  hide-actions
                  class="elevation-1 table2"
                >
                  <template v-slot:items="props">
                    <td>{{ props.item.netajet }} ml</td>
                    <td>{{ props.item.total.toFixed() }} ml</td>
                    <td>
                      {{ parseInt(props.item["mg Na riego"]).toFixed() }} mg
                    </td>
                    <td>
                      {{ parseInt(props.item["mg Na drenaje"]).toFixed() }} mg
                    </td>
                    <td>{{ parseInt(props.item.balance).toFixed() }}</td>
                    <td
                      :class="
                        props.item.drenaje < 0.2
                          ? 'war text-xs-center'
                          : 'text-xs-center'
                      "
                    >
                      {{ (props.item.drenaje * 100).toFixed() }}%
                    </td>
                  </template>
                </v-data-table>
              </v-flex>
              <v-flex xs1 sm1 md1 lg1>
                <v-data-table
                  :headers="headers3"
                  :items="query"
                  :pagination.sync="pagination"
                  must-sort
                  rows-per-page-text
                  hide-actions
                  class="elevation-1 table2"
                >
                  <template v-slot:items="props">
                    <td
                      :class="
                        props.item.drenaje < 0.2
                          ? 'war text-xs-center'
                          : 'text-xs-center'
                      "
                    >
                      {{ (props.item.drenaje * 100).toFixed() }}%
                    </td>
                  </template>
                </v-data-table>
              </v-flex>
            </v-layout>
            <br />
          </template>

          <!-- <template v-if="isWeekend">
            <v-layout row justify-center>
              <v-flex>
                <v-data-table
                  :headers="headers2N"
                  :items="data2"
                  :pagination.sync="pagination"
                  must-sort
                  rows-per-page-text
                  hide-actions
                  class="elevation-1 table2"
                >
                  <template v-slot:items="props">
                    <td>{{ props.item.nave }}</td>
                    <td>{{ props.item.sector }}</td>
                    <td>{{ props.item.netajet }} ml</td>
                    <td>{{ props.item.total.toFixed() }} ml</td>
                    <td>
                      {{ parseInt(props.item["mg Na riego"]).toFixed() }} mg
                    </td>
                    <td>
                      {{ parseInt(props.item["mg Na drenaje"]).toFixed() }} mg
                    </td>
                    <td>{{ parseInt(props.item.balance).toFixed() }}</td>
                    <td>{{ (props.item.drenaje * 100).toFixed() }}%</td>
                  </template>
                </v-data-table>
              </v-flex>
              <v-flex>
                <v-data-table
                  :headers="headers3"
                  :items="query"
                  :pagination.sync="pagination"
                  must-sort
                  rows-per-page-text
                  hide-actions
                  class="elevation-1 table2"
                >
                  <template v-slot:items="props">
                    <td>{{ (props.item.drenaje * 100).toFixed() }}%</td>
                  </template>
                </v-data-table>
              </v-flex>
            </v-layout>
          </template> -->
          <br />
        </div>

        <!-- Varillas -->
        <template>
          <v-layout row wrap>
            <v-flex>
              <h2>Varillas</h2>
            </v-flex>
            <v-flex>
              <h5 class="text-xs-right">{{ fecha }}</h5>
            </v-flex>
          </v-layout>
          <v-data-table
            :headers="headersVarilla"
            :items="arr"
            :pagination.sync="pagination"
            must-sort
            hide-actions
            class="elevation-1"
          >
            <template v-slot:items="props">
              <td>{{ Object.keys(props.item)[0] }}</td>
              <td class="text-xs-center">
                {{ props.item[Object.keys(props.item)].sector }}
              </td>
              <td class="text-xs-center">
                {{
                  (
                    props.item[Object.keys(props.item)].averageCE * 1.637 +
                    0.556
                  ).toFixed(2)
                }}
              </td>
              <td class="text-xs-center">
                {{ props.item[Object.keys(props.item)].averagePH.toFixed(2) }}
              </td>
            </template>
          </v-data-table>
        </template>
      </div>
    </div>
  </div>
</template>

<script>
const Loading = () => import("../components/resources/Loading.vue");
import moment from "moment-timezone";
import axiosApi from "../axios-api";

export default {
  components: {
    Loading,
  },
  data() {
    return {
      showLoading: false,
      ready: false,
      ready2: false,
      readySoil: false,
      progress: false,
      fecha: null,
      depthA: 0,
      depthC: 0,
      dateA: new Date(new Date().setHours(new Date().getHours() - 4))
        .toISOString()
        .substr(0, 10),
      // dateA: null,
      date: new Date().toISOString().substr(0, 10),
      // date2: new Date().toISOString().substr(0, 10),
      calendar: null,
      menu: false,
      menu2: false,
      modal: false,
      modal2: false,
      isVarilla: true,
      headers: [
        { text: "Nave", sortable: false, value: "nave" },
        { text: "Sector", value: "sector", sortable: false },
        { text: "CE Gotero", value: "CE Gotero", sortable: false },
        { text: "CE Drenaje", value: "CE Drenaje", sortable: false },
        { text: "pH Goter", value: "pH Gotero", sortable: false },
        { text: "pH Drenaje", value: "pH Drenaje", sortable: false },
      ],
      headers2: [
        {
          text: "Nave",
          sortable: false,
          value: "nave",
          align: " d-none",
        },
        { text: "Riego Net.", value: "netajet", sortable: false },
        { text: "Riego Gotero", value: "total", sortable: false },
        { text: "mg Na Riego", value: "mg Na riego", sortable: false },
        { text: "mg Na Drenaje", value: "mg Na drenaje", sortable: false },
        { text: "Balance", value: "balance", sortable: false },
        { text: "Drenaje", value: "drenaje", sortable: false },
      ],
      headers2N: [
        {
          text: "Nave",
          align: "left",
          sortable: false,
          value: "nave",
          // align: ' d-none'
        },
        { text: "Sector", value: "sector", sortable: false },
        { text: "Riego Netajet", value: "netajet", sortable: false },
        { text: "Riego Gotero", value: "total", sortable: false },
        { text: "mg Na Riego", value: "mg Na riego", sortable: false },
        { text: "mg Na Drenaje", value: "mg Na drenaje", sortable: false },
        { text: "Balance", value: "balance", sortable: false },
        { text: "Drenaje", value: "drenaje", sortable: false },
      ],
      headers3: [
        { text: "Nave", value: "nave", align: " d-none", sortable: false },
        {
          text: "D. Anterior.",
          child: ["December"],
          value: "% Drenaje del Dia anterior",
          sortable: false,
        },
      ],
      headersAgroBot: [
        {
          text: "Nave",
          align: "left",
          sortable: false,
          value: "nave",
        },
        {
          text: "CE Sustrato (dS/m)*",
          value: "ce",
          align: "center",
          sortable: false,
        },
        {
          text: "CE Sustrato Último (dS/m)**",
          value: "ce",
          align: "center",
          sortable: false,
        },
        {
          text: "CE Agua (dS/m)*",
          value: "ce",
          align: "center",
          sortable: false,
        },
        {
          text: "CE Agua Último (dS/m)**",
          value: "ce",
          align: "center",
          sortable: false,
        },
        {
          text: "pH Promedio ",
          value: "pH",
          align: "center",
          sortable: false,
        },
        {
          text: "Gotero (ml)",
          value: "gotero",
          align: "center",
          sortable: false,
        },
        {
          text: "mg Na Riego ***",
          value: "gotero",
          align: "center",
          sortable: false,
        },
        {
          text: "Drenaje (ml)",
          value: "drenaje",
          align: "center",
          sortable: false,
        },
        {
          text: "Drenaje %",
          value: "drenaje",
          align: "center",
          sortable: false,
        },
      ],
      headersAgroBotSoil: [
        {
          text: "Nave",
          align: "left",
          sortable: false,
          value: "nave",
        },
        {
          text: `CE Sustrato Prom. 1(dS/m)*`,
          value: "ce",
          align: "center",
          sortable: false,
        },
        {
          text: `CE Sustrato Último 1 (dS/m)**`,
          value: "ce",
          align: "center",
          sortable: false,
        },
        {
          text: `Humedad 1 `,
          value: "%",
          align: "center",
          sortable: false,
        },
        {
          text: `Humedad 2`,
          value: "%",
          align: "center",
          sortable: false,
        },
      ],
      headersAgroBotLight: [
        {
          text: "Nave",
          align: "left",
          sortable: false,
          value: "nave",
        },
        {
          text: "CE Sustrato (dS/m)*",
          value: "ce",
          align: "center",
          sortable: false,
        },
        {
          text: "CE Sustrato Último (dS/m)**",
          value: "ce",
          align: "center",
          sortable: false,
        },
        {
          text: "Gotero (ml)",
          value: "gotero",
          align: "center",
          sortable: false,
        },
        {
          text: "mg Na Riego ***",
          value: "gotero",
          align: "center",
          sortable: false,
        },
        {
          text: "Drenaje (ml)",
          value: "drenaje",
          align: "center",
          sortable: false,
        },
        {
          text: "Drenaje %",
          value: "drenaje",
          align: "center",
          sortable: false,
        },
      ],
      headersVarilla: [
        {
          text: "Nave",
          align: "left",
          sortable: false,
          value: "nave",
        },
        {
          text: "Sector Riego Q",
          value: "sector",
          align: "center",
          sortable: false,
        },
        {
          text: "CE promedio",
          value: "CE promedio",
          align: "center",
          sortable: false,
        },
        {
          text: "pH promedio",
          value: "pH promedio",
          align: "center",
          sortable: false,
        },
      ],
      groupBy: [],
      groupItems: [],
      arr: [],
      items: [],
      data2: [],
      paskal: [],
      query: [],
      varillaItems: [],
      isWeekend: false,
      pagination: {
        descending: false,
        page: 1,
        rowsPerPage: 15,
        totalItems: 0,
      },
      picker: new Date().toISOString().substr(0, 10),
      proDevices: [],
      landscape: false,
      reactive: false,
      yesterday: null,
      today: null,
      agroBotBasic: [],
      agroBotLight: [],
      agroBotSoil: [],
    };
  },
  computed: {
    rancho() {
      return this.$store.getters.subProject;
    },
  },
  watch: {
    rancho() {
      this.arr = [];
      this.proDevices = this.$store.state.proDevices;
      this.getData();
      this.initialLoad();
      this.ready = false;
    },
  },
  created() {
    let day = new Date().getDay();
    this.isWeekend = day === 6 || day === 0;

    this.today = moment().format("MMMM Do YYYY");

    this.yesterday = moment()
      .subtract(1, "days")
      .format("MMMM Do YYYY");

    this.getData();

    console.log("Date", this.dateA);
    // this.dateA.setHours(this.dateA.getHours() - 4);
  },
  beforeUpdate() {
    this.proDevices = this.$store.state.proDevices;
  },
  beforeMount() {
    this.proDevices = this.$store.state.proDevices;
  },
  mounted() {
    this.initialLoad();
    this.calendarClick();
  },
  methods: {
    initialLoad() {
      this.$axios
        .get(`/api/VarillaReportsDaily/${this.rancho}`)
        .then((data) => {
          this.varillaItems = data.data;
          this.fecha = this.varillaItems[0].createdAt;
          this.fecha = moment(this.fecha)
            .locale("ES")
            .format("LL");

          this.varillaItems.forEach((element) => {
            element.averageCE =
              (element["CE arriba"] +
                element["CE medio"] +
                element["CE abajo"]) /
              3;
            element.averagePH =
              (element["pH arriba"] +
                element["pH medio"] +
                element["pH abajo"]) /
              3;
          });

          const groupBy = (key) => (array) =>
            array.reduce(
              (objectsByKeyValue, obj) => ({
                ...objectsByKeyValue,
                [obj[key]]: (objectsByKeyValue[obj[key]] || []).concat(obj),
              }),
              {}
            );

          this.groupByNave = groupBy("nave");
          this.groupItems = this.groupByNave(this.varillaItems);
          this.keys = Object.keys(this.groupItems);

          for (var key in this.groupItems) {
            let totalNumbers = [];
            let totalNumbers2 = [];
            let totalSector = [];
            this.groupItems[key].forEach((element) => {
              totalNumbers.push(element.averageCE);
              totalNumbers2.push(element.averagePH);
              totalSector.push(element.sector);
            });

            const sum = totalNumbers.reduce((a, b) => a + b, 0);
            const avgCE = sum / totalNumbers.length || 0;
            const sum2 = totalNumbers2.reduce((a, b) => a + b, 0);
            const avgPH = sum2 / totalNumbers2.length || 0;
            const sector = totalSector[0];

            this.arr.push({
              [key]: {
                averageCE: avgCE,
                averagePH: avgPH,
                sector: sector,
              },
            });
          }

          this.arr.reverse();
        });
    },
    close() {
      this.arr = [];
      this.modal = false;
    },
    calendarClick() {
      this.showLoading = true;
      this.$refs.calendar.save(this.dateA);

      this.agroBotBasic = [];
      this.agroBotLight = [];
      this.agroBotSoil = [];

      this.ready = false;
      this.ready2 = false;
      this.readySoil = false;
      this.fetchMessages();
    },
    onClick() {
      this.$refs.menu.save(this.date);

      let day = new Date(this.date).getDay();
      this.isWeekend = day === 5 || day === 6;

      this.getData();
      this.getHistoric();
    },
    getLightData() {},
    fetchMessages() {
      this.agroBotBasic = this.$store.state.agroBotBasic.concat(
        this.$store.state.agroBotComp
      );
      this.agroBotBasic.sort((a, b) => (a.name > b.name ? 1 : -1));
      let itemsProcessed = 0;

      this.agroBotBasic.forEach(async (Device) => {
        let Tsoil = Device.specificTypeParameters.soilTemperature;
        let vwc = this.parseHumidity(
          Device.specificTypeParameters.volumetricWaterContent
        );
        let rawHumidity = Device.specificTypeParameters.volumetricWaterContent;
        let rawEC = Device.specificTypeParameters.electricConductivity;
        Device.specificTypeParameters.volumetricWaterContent = Math.round(vwc);
        Device.specificTypeParameters.electricConductivityParsed = (
          this.ecParser(rawHumidity, rawEC, vwc, Tsoil) * 1.637 +
          0.556
        ).toFixed(2);

        let yesterday = new Date(new Date(this.dateA).setHours(0) - 6);
        let today = new Date(new Date(this.dateA).setHours(23) - 6);
        yesterday.setDate(yesterday.getDate() + 1);
        today.setDate(today.getDate() + 1);

        let params = {
          sigfoxDeviceId: Device.sigfoxId,
          startDate: yesterday,
          endDate: today,
        };

        console.log("Params", params);

        await axiosApi
          .get(`/message/get-by-device`, {
            params,
          })
          .then((response) => {
            let payload = null;
            if (
              !response.data[response.data.length - 1].pulseCounter &&
              response.data[response.data.length - 1].rainGaugeCount
            ) {
              payload =
                (response.data[response.data.length - 1].rainGaugeCount -
                  response.data[response.data.length - 1].raindropsCut) *
                10;
            } else {
              payload =
                (response.data[response.data.length - 1].pulseCounter -
                  response.data[response.data.length - 1].pulseCut) *
                10;
            }

            Device.specificTypeParameters.yesterdayTotalPulses =
              payload / Device.status;

            let messages = response.data;
            let avrgES = 0;
            let avrgEC = 0;
            let lastEC = 0;
            let lastES = 0;
            let acumulator = 0;
            let counter = 0;
            let counter2 = 0;

            messages.forEach((message) => {
              let Tsoil = message.soilTemperature;
              let vwc = this.parseHumidity(message.volumetricWaterContent);
              let rawHumidity = message.volumetricWaterContent;
              let rawEC = message.electricConductivity;
              let EC = this.ecParser(rawHumidity, rawEC, vwc, Tsoil);

              if (Device.sigfoxId == "117229" || Device.sigfoxId == "40C675") {
                EC = EC * 1.15;
              } else {
                EC = EC * 1.637 + 0.556;
              }
              avrgEC += EC;
              avrgES += message.electricConductivityES;
              Device.specificTypeParameters.avrgEC = (
                avrgEC / messages.length
              ).toFixed(2);

              if (
                message.rainGaugeCount &&
                message.rainGaugeCount > message.previousRainGauge
              ) {
                lastEC = EC;
                lastES = message.electricConductivityES;
                counter += EC;
                counter2 += message.electricConductivityES / 1000;
                acumulator += 1;
                Device.specificTypeParameters.avrgDrainEC = (
                  counter / acumulator
                ).toFixed(2);
                Device.specificTypeParameters.avrgDrainES = (
                  counter2 / acumulator
                ).toFixed(2);
              } else if (
                message.pulseCounter &&
                message.pulseCounter > message.previousRainGauge
              ) {
                lastEC = EC;
                lastES = message.electricConductivityES;
                counter += EC;
                counter2 += message.electricConductivityES / 1000;
                acumulator += 1;
                Device.specificTypeParameters.avrgDrainEC = (
                  counter / acumulator
                ).toFixed(2);
                Device.specificTypeParameters.avrgDrainES = (
                  counter2 / acumulator
                ).toFixed(2);
              }
            });

            Device.specificTypeParameters.lastEC = lastEC.toFixed(2);
            Device.specificTypeParameters.lastES = (lastES / 1000).toFixed(2);
            Device.specificTypeParameters.avgElectricConductivity = (
              avrgEC / messages.length
            ).toFixed(2);

            Device.specificTypeParameters.avgElectricConductivityES = (
              avrgES / messages.length
            ).toFixed(2);
          });

        for (const Comp of this.$store.state.devices) {
          let name = Device.name.split("-");
          let name2 = Comp.name.split("-");
          if (name[0] == name2[0]) {
            let yesterday = new Date(new Date(this.dateA).setHours(0));
            let today = new Date(new Date(this.dateA).setHours(23));
            yesterday.setDate(yesterday.getDate() + 1);
            today.setDate(today.getDate() + 1);

            let params = {
              sigfoxDeviceId: Comp.sigfoxId,
              startDate: yesterday,
              endDate: today,
            };

            Device.specificTypeParameters.pH =
              Comp.specificTypeParameters.humidity / 10;
            Device.specificTypeParameters.pH = (
              -7.2 * Device.specificTypeParameters.pH +
              15.509
            ).toFixed(2);

            Device.specificTypeParameters.pH =
              Device.specificTypeParameters.pH > 15
                ? 0
                : Device.specificTypeParameters.pH;

            await axiosApi
              .get(`/message/get-by-device`, {
                params,
              })
              .then((response) => {
                // console.log("response", response)
                if (response.data.length > 0) {
                  let payload =
                    (response.data[response.data.length - 1].pulse -
                      response.data[response.data.length - 1].pulseCut) *
                    10;
                  Device.specificTypeParameters.yesterdayTotalPulsesComp =
                    payload * Comp.status;
                  let messages = response.data;
                  let avrgPH = 0;
                  messages.forEach((message) => {
                    avrgPH += -7.2 * (message.humidity / 1000) + 15.509;
                  });
                  Device.specificTypeParameters.avrgPH = (
                    avrgPH / messages.length
                  ).toFixed(2);
                } else {
                  Device.specificTypeParameters.yesterdayTotalPulsesComp = 0;
                  Device.specificTypeParameters.avrgPH = 0;
                }
              });
          } else {
            // console.log("chompiras");
          }
        }

        itemsProcessed++;
        if (itemsProcessed === this.agroBotBasic.length) {
          this.ready = true;
          this.showLoading = false;
        }
      });

      this.agroBotLight = this.$store.state.agroBotLight;
      this.agroBotLight.forEach(async (Device) => {
        let Tsoil = Device.specificTypeParameters.soilTemperature;
        let vwc = this.parseHumidity(
          Device.specificTypeParameters.volumetricWaterContent
        );
        let rawHumidity = Device.specificTypeParameters.volumetricWaterContent;
        let rawEC = Device.specificTypeParameters.electricConductivity;
        Device.specificTypeParameters.volumetricWaterContent = Math.round(vwc);
        Device.specificTypeParameters.electricConductivityParsed = (
          this.ecParser(rawHumidity, rawEC, vwc, Tsoil) * 1.637 +
          0.556
        ).toFixed(2);

        let yesterday = new Date(new Date(this.dateA).setHours(0));
        let today = new Date(new Date(this.dateA).setHours(23));
        yesterday.setDate(yesterday.getDate() + 1);
        today.setDate(today.getDate() + 1);

        let params = {
          sigfoxDeviceId: Device.sigfoxId,
          startDate: yesterday,
          endDate: today,
        };

        // await this.$axios
        //   .get(
        //     `https://listener.rabiahostal.com.mx/api/message/get-by-device`,
        await axiosApi
          .get(`/message/get-by-device`, {
            params,
          })
          .then((response) => {
            let payloadA = null;
            let payloadB = null;

            payloadA =
              (response.data[response.data.length - 1].pulseCounterA -
                response.data[response.data.length - 1].pulseCutA) *
              10;

            payloadB =
              (response.data[response.data.length - 1].pulseCounterB -
                response.data[response.data.length - 1].pulseCutB) *
              10;

            Device.specificTypeParameters.yesterdayTotalPulsesA = payloadA;
            Device.specificTypeParameters.yesterdayTotalPulsesB =
              payloadB / Device.status;

            let messages = response.data;
            let avrgEC = 0;
            let lastEC = 0;
            let acumulator = 0;
            let counter = 0;

            messages.forEach((message) => {
              let Tsoil = message.soilTemperature;
              let vwc = this.parseHumidity(message.volumetricWaterContent);
              let rawHumidity = message.volumetricWaterContent;
              let rawEC = message.electricConductivity;
              let EC = this.ecParser(rawHumidity, rawEC, vwc, Tsoil);

              // POUR THROUGH METHOD (PT)
              EC = EC * 1.637 + 0.556;

              avrgEC += EC;

              Device.specificTypeParameters.avrgEC = (
                avrgEC / messages.length
              ).toFixed(2);

              lastEC = EC;
              counter += EC;
              acumulator += 1;
              Device.specificTypeParameters.avrgDrainEC = (
                counter / acumulator
              ).toFixed(2);
            });
            Device.specificTypeParameters.lastEC = lastEC.toFixed(2);
            Device.specificTypeParameters.avgElectricConductivity = (
              avrgEC / messages.length
            ).toFixed(2);
          });

        this.ready2 = true;
      });

      this.agroBotSoil = [];
      this.agroBotSoil = this.$store.state.agroBotSoil;

      let soilDevices = 0;

      this.agroBotSoil.forEach(async (Device) => {
        // let TsoilA = Device.specificTypeParameters.soilTemperatureA;
        let vwcA = this.parseHumiditySoil(
          Device.specificTypeParameters.volumetricWaterContentA
        );
        let vwcC = this.parseHumiditySoil(
          Device.specificTypeParameters.volumetricWaterContentC
        );
        // let rawHumidityA =
        Device.specificTypeParameters.volumetricWaterContentA;
        // let rawEC = Device.specificTypeParameters.electricConductivityA;
        Device.specificTypeParameters.volumetricWaterContentA = Math.round(
          vwcA
        );
        Device.specificTypeParameters.volumetricWaterContentC = Math.round(
          vwcC
        );

        let yesterday = new Date(new Date(this.dateA).setHours(0));
        let today = new Date(new Date(this.dateA).setHours(18));
        yesterday.setDate(yesterday.getDate() + 1);
        today.setDate(today.getDate() + 1);

        let params = {
          sigfoxDeviceId: Device.sigfoxId,
          startDate: yesterday,
          endDate: today,
        };

        console.log("test", params);

        // await this.$axios
        //   .get(
        //     `https://listener.rabiahostal.com.mx/api/message/get-by-device`,
        await axiosApi
          .get(`/message/get-by-device`, {
            params,
          })
          .then((response) => {
            let messages = response.data;
            let avrgEC = 0;
            // let lastEC = 0;
            let avrHumA = 0;
            let avrHumB = 0;

            messages.forEach((message) => {
              let TsoilA = message.soilTemperatureA;
              let vwcA = this.parseHumiditySoil(
                message.volumetricWaterContentA
              );
              avrHumA = avrHumA + vwcA;
              let vwcC = this.parseHumiditySoil(
                message.volumetricWaterContentC
              );
              avrHumB = avrHumB + vwcC;
              let rawHumidityA = message.volumetricWaterContentA;
              // let rawHumidityC = message.volumetricWaterContentC;
              let rawEC = message.electricConductivityA;
              let EC = this.ecParser(rawHumidityA, rawEC, vwcA, TsoilA);
              if (this.$store.state.companyId == 10) {
                console.log("chuy");
                EC = EC * 0.86;
                Device.specificTypeParameters.electricConductivityParsed = EC.toFixed(
                  2
                );
              } else {
                EC = EC * 1.637 + 0.556;
                Device.specificTypeParameters.electricConductivityParsed = EC.toFixed(
                  2
                );
              }
              avrgEC += EC;
            });

            let AvrEC = avrgEC / messages.length;

            if (this.$store.state.companyId == 10) {
              Device.specificTypeParameters.avrgEC = AvrEC.toFixed(2);
            } else {
              Device.specificTypeParameters.avrgEC = AvrEC.toFixed(2);
            }

            Device.specificTypeParameters.avrHumA = (
              avrHumA / messages.length
            ).toFixed();
            Device.specificTypeParameters.avrHumB = (
              avrHumB / messages.length
            ).toFixed();

            Device.specificTypeParameters.avgElectricConductivity = (
              avrgEC / messages.length
            ).toFixed(2);
          });
        soilDevices++;
        if (soilDevices === this.agroBotSoil.length) {
          console.log("Device", Device);
          this.readySoil = true;
          this.showLoading = false;
        }
      });

      if (this.$store.state.subProjectId == "23") {
        this.showLoading = false;
      }
    },
    getData: function() {
      this.$axios
        .get(`/api/CeReportsByDate/${this.rancho}/${new Date(this.date)}`)
        .then((data) => {
          this.items = data.data;
        });

      this.$axios
        .get(
          `/api/IrrigationReportsByDate/${this.rancho}/${new Date(this.date)}`
        )
        .then((data) => {
          this.data2 = data.data;
        });

      let yesterday = new Date(new Date(this.date).setHours(0));
      let today = new Date(new Date(this.date).setHours(0));
      today.setDate(today.getDate() + 1);
      yesterday.setDate(yesterday.getDate());

      this.$axios
        .get(
          `/api/IrrigationReportsQueryByDate/${this.rancho}/${today}/${yesterday}`
        )
        .then((data) => {
          this.query = data.data;
        });
    },
    getHistoric() {
      this.arr = [];
      let yesterday = new Date(new Date(this.date).setHours(0));
      let today = new Date(new Date(this.date).setHours(0));
      today.setDate(today.getDate() + 2);
      yesterday.setDate(yesterday.getDate() + 1);

      this.$axios
        .get(`/api/VarillaReportsHistoric/${this.rancho}/${today}/${yesterday}`)
        .then((data) => {
          this.varillaItems = data.data;
          this.fecha = this.varillaItems[0].createdAt;
          this.fecha = moment(this.fecha)
            // .locale()
            .format("LL");

          this.varillaItems.forEach((element) => {
            element.averageCE =
              (element["CE arriba"] +
                element["CE medio"] +
                element["CE abajo"]) /
              3;
            element.averagePH =
              (element["pH arriba"] +
                element["pH medio"] +
                element["pH abajo"]) /
              3;
          });

          const groupBy = (key) => (array) =>
            array.reduce(
              (objectsByKeyValue, obj) => ({
                ...objectsByKeyValue,
                [obj[key]]: (objectsByKeyValue[obj[key]] || []).concat(obj),
              }),
              {}
            );

          this.groupByNave = groupBy("nave");
          this.groupItems = this.groupByNave(this.varillaItems);
          this.keys = Object.keys(this.groupItems);

          for (var key in this.groupItems) {
            let totalNumbers = [];
            let totalNumbers2 = [];
            let totalSector = [];
            this.groupItems[key].forEach((element) => {
              totalNumbers.push(element.averageCE);
              totalNumbers2.push(element.averagePH);
              totalSector.push(element.sector);
            });

            const sum = totalNumbers.reduce((a, b) => a + b, 0);
            const avgCE = sum / totalNumbers.length || 0;
            const sum2 = totalNumbers2.reduce((a, b) => a + b, 0);
            const avgPH = sum2 / totalNumbers2.length || 0;
            const sector = totalSector[0];

            this.arr.push({
              [key]: {
                averageCE: avgCE,
                averagePH: avgPH,
                sector: sector,
              },
            });
          }

          this.arr.reverse();
        });
    },
    //PARSER FOR ELECTRICAL CONDUCTIVITY
    //RAW = READING FROM DEVICE, TSOIL = TEMPERATURE SOIL, VWC = VOLUMETRIC WATER CONTENT
    parseHumidity(raw) {
      let vwc =
        (6.77 * Math.pow(10, -10) * Math.pow(raw, 3) -
          5.105 * Math.pow(10, -6) * Math.pow(raw, 2) +
          1.302 * Math.pow(10, -2) * raw -
          10.848) *
        100;
      return vwc;
    },
    parseHumiditySoil(raw) {
      let vwc = (3.879 * Math.pow(10, -4) * raw - 0.6956) * 100;
      return vwc;
    },
    ecParser(rawHumidity, rawEC, vwc, Tsoil) {
      //Parsed Volumetric Water Content
      let Om = vwc / 100;
      //ELECTRICAL CONDUCTIVITY DESTILLED WATER
      let Od = 0;
      //USING EXAMPLE 1.5Mg/m3 REAL 1.48
      let Pb = 1.5;
      //USING EXAMPLE 2.65Mg/m3
      let Ps = 2.65;
      //Dielectric permittivity
      let Ep = 80.3 - 0.37 * Tsoil - 20;
      //Segun HILHOST 2000!?
      let Eab = 4.1;
      //Real portion of the dielectric permittivity of the bulk soil
      let Eb = Math.pow(
        2.887 * Math.pow(10, -9) * Math.pow(rawHumidity, 3) -
          2.08 * Math.pow(10, -5) * Math.pow(rawHumidity, 2) +
          5.276 * Math.pow(10, -2) * rawHumidity -
          43.39,
        2
      );

      //Pore water conductivity
      let Op = (Ep * rawEC) / (Eb - Eab);
      let Porosity = 1 - Pb / Ps;
      //Saturation extract EC
      let solutionEC = (Op * Om + Od) / Porosity;
      return solutionEC;
    },
  },
};
</script>

<style scoped>
.card {
  padding-top: 50px !important;
  padding-bottom: 50px !important;
  padding-left: 15px !important;
  padding-right: 75px !important;
  width: 1200px !important;
}

.title {
  margin-bottom: 0px;
}

th {
  padding-top: 12px;
  padding-bottom: 12px;
  text-align: left;
  background-color: rgb(156, 204, 101);
  color: white;
}

h1,
h2 {
  font-weight: bold;
}

.naveBtn {
  color: black !important;
}

#progress {
  margin-right: 10px;
}

.update {
  margin-top: -30px;
}

.table2 {
  margin-left: -2px;
}

.err {
  color: #e53935;
}
.war {
  color: #ff9800;
}

@media only screen and (max-width: 900px) {
  .container {
    width: 2000px !important;
    height: 50% !important;
    margin-left: 0 !important;
    background-color: white !important;
    zoom: 30% !important;
  }

  .card {
    width: 100% !important;
    padding-top: 50px !important;
    padding-bottom: 50px !important;
    background-color: white !important;
  }
}

@media only screen and (max-width: 600px) {
  .container {
    width: 100% !important;
    height: 70% !important;
    zoom: 30% !important;
    margin-left: 0 !important;
    background-color: white !important;
  }

  .card {
    width: 100% !important;
    padding-top: 50px !important;
    padding-bottom: 50px !important;
    padding-left: 0px !important;
    background-color: white !important;
  }
}
</style>
